import { Refresh } from '@browser/Browser';
import { calculateProportionOf, parseOptionalNumber, sumOrDefault, toPercentageString, toStringSmartly } from '@common/Common';
import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { NumericInputDialogViewModel } from '@common/Components/NumericInputDialog';
import NumericInputDialog from '@common/Components/NumericInputDialog.vue';
import ScenarioNavigation from '@Quest/CorporateScenarios/Components/ScenarioNavigation.vue';
import { OptimizeCorporateScenarioScheduleCommandV1, SetPortfolioResourceAllocationCommandV1, UpdateActivePortfolioScenarioCommandV1 } from '@Quest/CorporateScenarios/Domain/commands-core';
import CorporateScenariosCommands from '@Quest/CorporateScenarios/Domain/commands-vue-component';
import CorporateScenariosQueries from '@Quest/CorporateScenarios/Domain/queries-vue-component';
import { BudgetAllocationSummaryReadModel, PortfolioBudgetAllocationReadModel, PortfolioResourceAllocationReadModel, PortfoliosPageReadModel, PortfolioSummaryReadModel, ResourceAllocationSummaryReadModel } from '@Quest/CorporateScenarios/Domain/readmodels';
import { ICommandBase } from '@Quest/cqrs';
import { SelectorDialogViewModel } from '@Quest/PortfolioScenarios/Components/SelectorDialog';
import SelectorDialog from '@Quest/PortfolioScenarios/Components/SelectorDialog.vue';
import { OptimizeSelectionCommandV1 } from '@Quest/PortfolioScenarios/Domain/commands-core';
import PortfolioScenariosCommands from '@Quest/PortfolioScenarios/Domain/commands-vue-component';
import { Component, mixins } from 'vue-facing-decorator';


@Component({ components: { CorporateNavigation, ScenarioNavigation, SelectorDialog, NumericInputDialog }})
export default class PortfoliosPage extends mixins(CorporateScenariosQueries, CorporateScenariosCommands, PortfolioScenariosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }
    get scenarioId() { return this.$route.params.scenarioId; }

    rm: PortfoliosPageReadModel | null = null;
    budget: BudgetAllocationSummaryViewModel | null = null;
    resources: ResourceAllocationSummaryViewModel[] = [];
    selectorDialog = new SelectorDialogViewModel();

    totalCostLimitEditorDialog: NumericInputDialogViewModel = new NumericInputDialogViewModel();
    opexLimitEditorDialog: NumericInputDialogViewModel = new NumericInputDialogViewModel();
    othexLimitEditorDialog: NumericInputDialogViewModel = new NumericInputDialogViewModel();
    capexLimitEditorDialog: NumericInputDialogViewModel = new NumericInputDialogViewModel();
    expensesLimitEditorDialog: NumericInputDialogViewModel = new NumericInputDialogViewModel();
    opexExpensesLimitEditorDialog: NumericInputDialogViewModel = new NumericInputDialogViewModel();
    portfolioResourceAllocationEditorDialog: NumericInputDialogViewModel = new NumericInputDialogViewModel();

    fmtNum(val: number | null) { return toStringSmartly(val); }

    fmtPct(val: number | null, decimalPlaces: number = 1) { return toPercentageString(val, decimalPlaces); }


    showSelectorDialog(rm: PortfolioSummaryReadModel)
    {
        this.selectorDialog.show(rm.WorkspaceId, rm.PortfolioId, rm.ScenarioId);
    }

    showTotalCostLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        this.totalCostLimitEditorDialog.id = p.Id;
        this.totalCostLimitEditorDialog.value = p.Limit;

        this.totalCostLimitEditorDialog.title = p.Name;
        this.totalCostLimitEditorDialog.label = `Total cost limit (${this.rm?.CurrencyLabel}):`;

        this.totalCostLimitEditorDialog.showValueRange = false;
        this.totalCostLimitEditorDialog.minValue = 0;
        this.totalCostLimitEditorDialog.show();
    }

    showOpexLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        this.opexLimitEditorDialog.id = p.Id;
        this.opexLimitEditorDialog.value = p.Limit;

        this.opexLimitEditorDialog.title = p.Name;
        this.opexLimitEditorDialog.label = `Opex limit (${this.rm?.CurrencyLabel}):`;

        this.opexLimitEditorDialog.showValueRange = false;
        this.opexLimitEditorDialog.minValue = 0;
        this.opexLimitEditorDialog.show();
    }

    showOthexLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        this.othexLimitEditorDialog.id = p.Id;
        this.othexLimitEditorDialog.value = p.Limit;

        this.othexLimitEditorDialog.title = p.Name;
        this.othexLimitEditorDialog.label = `Other expenses limit (${this.rm?.CurrencyLabel}):`;

        this.othexLimitEditorDialog.showValueRange = false;
        this.othexLimitEditorDialog.minValue = 0;
        this.othexLimitEditorDialog.show();
    }

    showExpensesLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        this.expensesLimitEditorDialog.id = p.Id;
        this.expensesLimitEditorDialog.value = p.Limit;

        this.expensesLimitEditorDialog.title = p.Name;
        this.expensesLimitEditorDialog.label = `Expenses limit (${this.rm?.CurrencyLabel}):`;

        this.expensesLimitEditorDialog.showValueRange = false;
        this.expensesLimitEditorDialog.minValue = 0;
        this.expensesLimitEditorDialog.show();
    }

    showOpexExpensesLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        this.opexExpensesLimitEditorDialog.id = p.Id;
        this.opexExpensesLimitEditorDialog.value = p.Limit;

        this.opexExpensesLimitEditorDialog.title = p.Name;
        this.opexExpensesLimitEditorDialog.label = `Opex expenses limit (${this.rm?.CurrencyLabel}):`;

        this.opexExpensesLimitEditorDialog.showValueRange = false;
        this.opexExpensesLimitEditorDialog.minValue = 0;
        this.opexExpensesLimitEditorDialog.show();
    }


    showCapexLimitEditor(p: PortfolioBudgetAllocationViewModel)
    {
        this.capexLimitEditorDialog.id = p.Id;
        this.capexLimitEditorDialog.value = p.Limit;

        this.capexLimitEditorDialog.title = p.Name;
        this.capexLimitEditorDialog.label = `Capex limit (${this.rm?.CurrencyLabel}):`;

        this.capexLimitEditorDialog.showValueRange = false;
        this.capexLimitEditorDialog.minValue = 0;
        this.capexLimitEditorDialog.show();
    }

    showPortfolioResourceAllocationEditorDialog(p: PortfolioResourceAllocationViewModel)
    {
        this.portfolioResourceAllocationEditorDialog.id = p.Id;
        this.portfolioResourceAllocationEditorDialog.value = p.TargetPercent != null ? 100 * p.TargetPercent : null;

        this.portfolioResourceAllocationEditorDialog.title = p.Name;
        this.portfolioResourceAllocationEditorDialog.label = `Target allocation (%):`;

        this.portfolioResourceAllocationEditorDialog.showValueRange = true;
        this.portfolioResourceAllocationEditorDialog.minValue = 0;
        this.portfolioResourceAllocationEditorDialog.maxValue = 200;
        this.portfolioResourceAllocationEditorDialog.step = 1;
        this.portfolioResourceAllocationEditorDialog.opener = p;
        this.portfolioResourceAllocationEditorDialog.show();
    }

    handlePortfolioResourceAllocationEditorUpdate(value: string | null)
    {
        const allocation = parseOptionalNumber(value);
        const p = this.portfolioResourceAllocationEditorDialog.opener as PortfolioResourceAllocationViewModel;
        const portfolioId = p.Id;
        const resourceId = p.root.Id;

        this.invokeSetPortfolioResourceAllocationCommandV1(this.workspaceId, this.strategyId, this.scenarioId, portfolioId, resourceId, allocation != null ? allocation / 100 : null);

        this.resources.find(r => r.Id === resourceId)?.setPortfolioAllocation(portfolioId, allocation);
        this.portfolioResourceAllocationEditorDialog.close();
    }


    handleUpdateActivePortfolioScenarioCommand(portfolioId: string, portfolioScenarioId: string)
    {
        this.invokeUpdateActivePortfolioScenarioCommandV1(this.workspaceId, this.strategyId, this.scenarioId, portfolioId, portfolioScenarioId);
    }


    handleSetPortfolioTotalCostLimitCommand(value: string | null, portfolioId: string): void
    {
        const limit = parseOptionalNumber(value);
        this.invokeSetPortfolioTotalCostLimitCommandV1(this.workspaceId, this.strategyId, this.scenarioId, portfolioId, limit);

        this.budget?.updateTotalCostLimit(portfolioId, limit);        
        this.totalCostLimitEditorDialog.close();
    }

    handleSetPortfolioCapexLimitCommand(value: string | null, portfolioId: string): void
    {
        const limit = parseOptionalNumber(value);
        this.invokeSetPortfolioCapexLimitCommandV1(this.workspaceId, this.strategyId, this.scenarioId, portfolioId, limit);

        this.budget?.updateCapexLimit(portfolioId, limit);        
        this.capexLimitEditorDialog.close();
    }

    handleSetPortfolioOpexLimitCommand(value: string | null, portfolioId: string)
    {
        const limit = parseOptionalNumber(value);
        this.invokeSetPortfolioOpexLimitCommandV1(this.workspaceId, this.strategyId, this.scenarioId, portfolioId, limit);
        this.budget?.updateOpexLimit(portfolioId, limit);
        this.opexLimitEditorDialog.close();
    }

    handleSetPortfolioOthexLimitCommand(value: string | null, portfolioId: string)
    {
        const limit = parseOptionalNumber(value);
        this.invokeSetPortfolioOthexLimitCommandV1(this.workspaceId, this.strategyId, this.scenarioId, portfolioId, limit);
        this.budget?.updateOthexLimit(portfolioId, limit);
        this.othexLimitEditorDialog.close();
    }

    handleSetPortfolioExpensesLimitCommand(value: string | null, portfolioId: string)
    {
        const limit = parseOptionalNumber(value);
        this.invokeSetPortfolioExpensesLimitCommandV1(this.workspaceId, this.strategyId, this.scenarioId, portfolioId, limit);
        this.budget?.updateExpensesLimit(portfolioId, limit);
        this.expensesLimitEditorDialog.close();
    }

    handleSetPortfolioOpexExpensesLimitCommand(value: string | null, portfolioId: string)
    {
        const limit = parseOptionalNumber(value);
        this.invokeSetPortfolioOpexExpensesLimitCommandV1(this.workspaceId, this.strategyId, this.scenarioId, portfolioId, limit);
        this.budget?.updateOpexExpensesLimit(portfolioId, limit);
        this.opexExpensesLimitEditorDialog.close();
    }


    mounted()
    {
        document.title = "Enterprise Plan - Portfolios";
        this.runPortfoliosPageQueryV1(this.workspaceId, this.strategyId, this.scenarioId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PortfoliosPageReadModel")
        {
            const rm = model as PortfoliosPageReadModel;
            this.resources = rm.Resources.map(r => new ResourceAllocationSummaryViewModel(r));
            this.budget = new BudgetAllocationSummaryViewModel(rm.Budget);
            this.rm = rm;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (UpdateActivePortfolioScenarioCommandV1.matchType(cmd))
        {
            Refresh();
        }
        else if (SetPortfolioResourceAllocationCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as SetPortfolioResourceAllocationCommandV1;

            const resource = this.resources.find(r => r.Id === cmd1.ResourceId);

            if (resource)
            {
                resource.setPortfolioAllocation(cmd1.PortfolioId, cmd1.Allocation);                
            }
        }
        else if (OptimizeSelectionCommandV1.matchType(cmd))
        {
            this.runPortfoliosPageQueryV1(this.workspaceId, this.strategyId, this.scenarioId);
        }
        else if (OptimizeCorporateScenarioScheduleCommandV1.matchType(cmd))
        {
            this.runPortfoliosPageQueryV1(this.workspaceId, this.strategyId, this.scenarioId);
        }
    }
}

class ResourceAllocationSummaryViewModel
{
    Id: string;
    Name: string;
    Unit: string;
    IsCollapsed: boolean;
    CapacityValue: number;
    Portfolios: PortfolioResourceAllocationViewModel[];

    get TargetPercent(): number | null { return sumOrDefault(this.Portfolios.map(a => a.TargetPercent)) }
    get TargetValue(): number | null { return sumOrDefault(this.Portfolios.map(a => a.TargetValue)); }
    get CurrentPercent(): number | null { return calculateProportionOf(this.CurrentValue, this.TargetValue); }
    get CurrentValue(): number | null { return sumOrDefault(this.Portfolios.map(a => a.CurrentValue)); }

    constructor(rm: ResourceAllocationSummaryReadModel)
    {
        this.Id = rm.Id;
        this.Name = rm.Name;
        this.Unit = rm.Unit;
        this.IsCollapsed = rm.IsCollapsed;
        this.CapacityValue = rm.CapacityValue;
        this.Portfolios = rm.Portfolios.map(p => new PortfolioResourceAllocationViewModel(this, p));
    }

    setPortfolioAllocation(portfolioId: string, allocation: number)
    {
        const portfolio = this.Portfolios.find(p => p.Id === portfolioId);

        if (portfolio)
        {
            portfolio.TargetPercent = allocation;
        }
    }
}

class PortfolioResourceAllocationViewModel
{
    root: ResourceAllocationSummaryViewModel;

    Id: string;
    Name: string;
    IsLinked: boolean;

    TargetPercent: number | null;
    CurrentValue: number | null;

    constructor(resource: ResourceAllocationSummaryViewModel, rm: PortfolioResourceAllocationReadModel)
    {
        this.root = resource;

        this.Id = rm.Id;
        this.Name = rm.Name;
        this.IsLinked = rm.IsLinked;
        this.TargetPercent = rm.TargetPercent;
        this.CurrentValue = rm.CurrentValue;
    }

    get TargetValue(): number | null
    {
        return this.TargetPercent === null ? null : this.TargetPercent * this.root.CapacityValue;
    }
    get CurrentPercent(): number | null { return calculateProportionOf(this.CurrentValue, this.TargetValue); }
}

class BudgetAllocationSummaryViewModel
{
    TotalCostItems: PortfolioBudgetAllocationViewModel[];
    CapexItems: PortfolioBudgetAllocationViewModel[];
    OpexItems: PortfolioBudgetAllocationViewModel[];
    OthexItems: PortfolioBudgetAllocationViewModel[];
    ExpensesItems: PortfolioBudgetAllocationViewModel[];
    OpexExpensesItems: PortfolioBudgetAllocationViewModel[];

    TotalCostCollapsed: boolean = true;
    CapexCollapsed: boolean = true;
    OpexCollapsed: boolean = true;
    OthexCollapsed: boolean = true;
    ExpensesCollapsed: boolean = true;
    OpexExpensesCollapsed: boolean = true;

    get TotalCostLimit(): number | null { return sumOrDefault(this.TotalCostItems.map(a => a.Limit)); }
    get TotalCostCurrentValue(): number | null { return sumOrDefault(this.TotalCostItems.map(a => a.CurrentValue)); }
    get CapexLimit(): number | null { return sumOrDefault(this.CapexItems.map(a => a.Limit)); }
    get CapexCurrentValue(): number | null { return sumOrDefault(this.CapexItems.map(a => a.CurrentValue)); }
    get OpexLimit(): number | null { return sumOrDefault(this.OpexItems.map(a => a.Limit)); }
    get OpexCurrentValue(): number | null { return sumOrDefault(this.OpexItems.map(a => a.CurrentValue)); }
    get OthexLimit(): number | null { return sumOrDefault(this.OthexItems.map(a => a.Limit)); }
    get OthexCurrentValue(): number | null { return sumOrDefault(this.OthexItems.map(a => a.CurrentValue)); }
    get ExpensesLimit(): number | null { return sumOrDefault(this.ExpensesItems.map(a => a.Limit)); }
    get ExpensesCurrentValue(): number | null { return sumOrDefault(this.ExpensesItems.map(a => a.CurrentValue)); }
    get OpexExpensesLimit(): number | null { return sumOrDefault(this.OpexExpensesItems.map(a => a.Limit)); }
    get OpexExpensesCurrentValue(): number | null { return sumOrDefault(this.OpexExpensesItems.map(a => a.CurrentValue)); }

    constructor(rm: BudgetAllocationSummaryReadModel)
    {
        this.TotalCostItems = rm.TotalCost.map(a => new PortfolioBudgetAllocationViewModel(this, a));
        this.CapexItems = rm.Capex.map(a => new PortfolioBudgetAllocationViewModel(this, a));
        this.OpexItems = rm.Opex.map(a => new PortfolioBudgetAllocationViewModel(this, a));
        this.OthexItems = rm.Othex.map(a => new PortfolioBudgetAllocationViewModel(this, a));
        this.ExpensesItems = rm.Expenses.map(a => new PortfolioBudgetAllocationViewModel(this, a));
        this.OpexExpensesItems = rm.OpexExpenses.map(a => new PortfolioBudgetAllocationViewModel(this, a));
    }

    updateTotalCostLimit(portfolioId: string, value: number | null)
    {
        const item = this.TotalCostItems.find(p => p.Id === portfolioId);

        if (item)
        {
            item.Limit = value;
        }
    }

    updateOpexLimit(portfolioId: string, value: number | null)
    {
        const item = this.OpexItems.find(p => p.Id === portfolioId);

        if (item)
        {
            item.Limit = value;
        }
    }

    updateOthexLimit(portfolioId: string, value: number | null)
    {
        const item = this.OthexItems.find(p => p.Id === portfolioId);

        if (item)
        {
            item.Limit = value;
        }
    }

    updateExpensesLimit(portfolioId: string, value: number | null)
    {
        const item = this.ExpensesItems.find(p => p.Id === portfolioId);

        if (item)
        {
            item.Limit = value;
        }
    }

    updateOpexExpensesLimit(portfolioId: string, value: number | null)
    {
        const item = this.OpexExpensesItems.find(p => p.Id === portfolioId);

        if (item)
        {
            item.Limit = value;
        }
    }

    updateCapexLimit(portfolioId: string, value: number | null)
    {
        const item = this.CapexItems.find(p => p.Id === portfolioId);

        if (item)
        {
            item.Limit = value;
        }
    }
}

class PortfolioBudgetAllocationViewModel
{
    root: BudgetAllocationSummaryViewModel;

    Id: string;
    Name: string;
    Limit: number | null;
    CurrentValue: number | null;

    constructor(root: BudgetAllocationSummaryViewModel, rm: PortfolioBudgetAllocationReadModel)
    {
        this.root = root;

        this.Id = rm.Id;
        this.Name = rm.Name;
        this.Limit = rm.Limit;
        this.CurrentValue = rm.CurrentValue;
    }
}